import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useNavigate } from "react-router-dom";
import { FaEdit, FaTrash, FaUserShield } from "react-icons/fa";
import StaffRoleModal from "../Setting/StaffRole/AddUpdateStaffRoleModal";
import AddUpdateServiceModal from "../Setting/Services/AddUpdateServiceModal";
import AddUpdateClientIndustryModal from "../Setting/ClientIndustry/AddUpdateClientIndustryModal";
import AddUpdateStatusTypeModal from "../Setting/StatusType/AddUpdateStatusTypeModal";
import AddUpdateClientGroupingModal from "../Setting/ClientGrouping/AddUpdateClientGroupingModal";
import AddUpdateLeaveTypeModal from "../Setting/LeaveType/AddUpdateLeaveTypeModal";
import Android12Switch from "../../components/common/AndroidSwitch";
import ConfirmationModal from "../../components/common/ConfirmationModal";
import SuccessModal from "../../components/common/SuccessModal";
import {
  ChangeRoleTypeStatus,
  DeleteRoleType,
  GetRoleTypeList,
} from "../../services/UserRole/UserRoleApi";
import { AuthContext, LoaderContext } from "../../Context/ContextFunctions";
import ErrorModal from "../../components/common/ErrorModal";
import PaginationComponent from "../../components/common/PaginationModal";
import {
  ChangeClientIndustryStatus,
  DeleteClientIndustry,
  GetClientIndustryList,
} from "../../services/ClientIndustry/ClientIndustryApi";
import {
  ChangeClientGroupStatus,
  DeleteClientGroup,
  GetClientGroupList,
} from "../../services/ClientGrouping/ClientGroupingApi";
import {
  ChangeLeaveTypeStatus,
  DeleteLeaveType,
  GetLeaveTypeList,
} from "../../services/LeaveType/LeaveTypeApi";
import AddupdateStaffModal from "./../Setting/Admin/AddupdateStaffModal";
import Pagination from "../../components/common/PaginationModal";
import AddUpdateContactPersonRoleModal from "./../Setting/ContactPersonRole/AddUpdateContactPersonRoleModal";
import AddUpdateKRAModal from "./../Setting/KRA/AddUpdateKRAModal";
import {
  ChangeServiceStatus,
  DeleteService,
  GetServiceList,
} from "../../services/Service/ServiceApi";
import { SettingEnum } from "../../middleware/enum";
import NoResultFoundModel from "../../components/common/NoDataFound";
import {
  ChangeDesignationStatus,
  DeleteDesignation,
  GetDesignationList,
} from "../../services/Designation/DesignationApi";
import {
  ChangeStatusStatus,
  DeleteStatus,
  GetStatusList,
} from "../../services/StatusType/StatusTypeApi";
import { ChangeKRAStatus, GetKRAList } from "../../services/KRA/KRAapi";
import { GetEmailTemplateList } from "../../services/EmailTemplate/EmailTemplateApi";
import ProjectStageAddUpdateModal from "../Setting/ProjectStages/AddUpdateprojectStageModal";
import {
  ChangeProjectStageStatus,
  DeleteProjectStage,
  GetProjectStageList,
  GetProjectStageLookupList,
} from "../../services/ProjectStage/ProjectStageApi";

const tabs = [
  { id: SettingEnum.UsersRole, label: "Users Role" },
  { id: SettingEnum.Designation, label: "Designation" },
  { id: SettingEnum.StatusType, label: "Status Type" },

  { id: SettingEnum.Services, label: "Services" },
  { id: SettingEnum.ClientIndustry, label: "Client Industry" },
  { id: SettingEnum.KRA, label: "KRA" },
  { id: SettingEnum.ClientGrouping, label: "Client Grouping" },
  { id: SettingEnum.LeaveType, label: "Leave Type" },
  { id: SettingEnum.EmailTemplate, label: "Email Template" },
  { id: SettingEnum.ProjectStage, label: "Project Stage" },

  // { id: 4, label: "Statuses" },
  // { id: 5, label: "Checklist" },
];

function Configure() {
  const navigate = useNavigate();

  const moduleName = "Predefined";

  const [activeTab, setActiveTab] = useState(() => {
    const storedTab = Number(localStorage.getItem("selectedTab"));
    const storedPath = localStorage.getItem("CurrentPath");
    return storedPath === "/configure" && storedTab ? storedTab : 1;
  });
  const [errorMessage, setErrorMessage] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
  //Context
  const { setLoader } = useContext(LoaderContext);
  const { authDetails, pageSize } = useContext(AuthContext);

  //user role Type variables
  const [RoleTypeSearch, setRoleTypeSearch] = useState("");

  const [userRoleList, setUserRoleList] = useState([]);
  const [RoleTypeListCount, setRoleTypeListCount] = useState(0);
  const [RoleTypeCurrentPage, setRoleTypeCurrentPage] = useState(1);
  const [isStaffRoleModalOpen, setStaffRoleModalOpen] = useState(false);
  const [isdesignationModalOpen, setDesignationModalOpen] = useState(false);

  const [openAccessModel, setOpenAccessModel] = useState(false);
  //Client industry
  const [ClientIndustrySearch, setClientIndustrySearch] = useState("");
  const [ClientIndustryList, setClientIndustryList] = useState([]);
  const [ClientIndustryListCount, setClientIndustryListCount] = useState(0);
  const [ClientIndustryCurrentPage, setClientIndustryCurrentPage] = useState(1);
  const [isClientIndustryModalOpen, setClientIndustryModalOpen] =
    useState(false);
  //Client Grouping
  const [ClientGroupingSearch, setClientGroupingSearch] = useState("");
  const [ClientGroupingList, setClientGroupingList] = useState([]);
  const [ClientGroupingListCount, setClientGroupingListCount] = useState(0);
  const [ClientGroupingCurrentPage, setClientGroupingCurrentPage] = useState(1);
  const [isGroupingOpen, setGroupingModalOpen] = useState(false);

  //Leave Type
  const [LeaveTypeSearch, setLeaveTypeSearch] = useState("");
  const [LeaveTypeList, setLeaveTypeList] = useState([]);
  const [LeaveTypeListCount, setLeaveTypeListCount] = useState(0);
  const [LeaveTypeCurrentPage, setLeaveTypeCurrentPage] = useState(1);
  const [isLeaveTypeOpen, setLeaveTypeModalOpen] = useState(false);

  const [OpenStatusAddModel, setOpenStatusAddModel] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);
  const [modelAction, setModelAction] = useState("");
  const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);

  //Designation variables
  const [DesignationSearch, setDesignationSearch] = useState("");
  const [DesignationList, setDesignationList] = useState([]);
  const [DesignationListCount, setDesignationListCount] = useState(-1);
  const [DesignationCurrentPage, setDesignationCurrentPage] = useState(1);
  const [openDesignationModel, setOpenDesignationModel] = useState(false);

  //status type
  const [StatusTypeSearch, setStatusTypeSearch] = useState("");
  const [StatusTypeList, setStatusTypeList] = useState([]);
  const [StatusTypeListCount, setStatusListCount] = useState(-1);
  const [StatusCurrentPage, setStatusCurrentPage] = useState(1);

  //KRA
  const [KRASearch, setKRASearch] = useState("");
  const [KRAList, setKRAList] = useState([]);
  const [KRAListCount, setKRAListCount] = useState(-1);
  const [KRACurrentPage, setKRACurrentPage] = useState(1);

  //Email Template
  const [TemplateSearch, setTemplateSearch] = useState("");

  const [templateList, setTemplateList] = useState([]);
  const [EmailTemplateSearch, setEmailTemplateSearch] = useState("");
  const [EmailTemplateListCount, setEmailTemplateListCount] = useState(-1);
  const [TemplateCurrentPage, setTemplateCurrentPage] = useState(1);

  //Services
  const [servicesSearch, setServicesSearch] = useState("");
  const [servicesList, setServicesList] = useState([]);
  const [servicesListCount, setServicesListCount] = useState(0);
  const [servicesCurrentPage, setServicesCurrentPage] = useState(1);
  const [isServiceModalOpen, setServiceModalOpen] = useState(false);

  //PRoject Stage
  const [ProjectStageSearch, setProjectStageSearch] = useState("");
  const [ProjectStageList, setProjectStageList] = useState([]);
  const [ProjectStageListCount, setProjectStageListCount] = useState(-1);
  const [ProjectStageListCurrentPage, setProjectStageListCurrentPage] =
    useState(1);
  const [OpenProjectStageListModel, setOpenProjectStageListModel] =
    useState(false);

  const handleOpenStageModal = () => setOpenProjectStageListModel(true);

  const handleCloseStageModal = () => setOpenProjectStageListModel(false);

  const [modelRequestData, setModelRequestData] = useState({
    KeyID: null,
    Action: null,
    status: null,
    Name: null,
  });

  const handleChangeTab = (tab) => {
    setActiveTab(tab);
    if (tab === SettingEnum.UsersRole) {
      GetUserRoleListData(1);
    } else if (tab === SettingEnum.ClientIndustry) {
      GetClientIndustryListData(1);
    } else if (tab === SettingEnum.ClientGrouping) {
      GetClientGroupListData(1);
    } else if (tab === SettingEnum.LeaveType) {
      GetLeaveTypeListData(1);
    } else if (tab === SettingEnum.Services) {
      GetServicesListData(1);
    } else if (tab === SettingEnum.Designation) {
      GetDesignationListData(1);
    } else if (tab === SettingEnum.StatusType) {
      GetStatusListData(1);
    } else if (tab === SettingEnum.KRA) {
      GetKRAListData(1);
    } else if (tab === SettingEnum.EmailTemplate) {
      GetEmailTemplateListData(1);
    } else if (tab === SettingEnum.ProjectStage) {
      GetProjectStageListData(1);
    }
  };

  //initial UseEffect
  useEffect(() => {
    if (activeTab === SettingEnum.UsersRole) {
      GetUserRoleListData(1);
    } else if (activeTab === SettingEnum.ClientIndustry) {
      GetClientIndustryListData(1);
    } else if (activeTab === SettingEnum.ClientGrouping) {
      GetClientGroupListData(1);
    } else if (activeTab === SettingEnum.LeaveType) {
      GetLeaveTypeListData(1);
    } else if (activeTab === SettingEnum.Services) {
      GetServicesListData(1);
    } else if (activeTab === SettingEnum.Designation) {
      GetDesignationListData(1);
    } else if (activeTab === SettingEnum.StatusType) {
      GetStatusListData(1);
    } else if (activeTab === SettingEnum.KRA) {
      GetKRAListData(1);
    } else if (activeTab === SettingEnum.EmailTemplate) {
      GetEmailTemplateListData(1);
    } else if (activeTab === SettingEnum.ProjectStage) {
      GetProjectStageListData(1);
    }
  }, []);

  useEffect(() => {
    if (isAddUpdateDone) {
      if (activeTab === SettingEnum.UsersRole) {
        setRoleTypeSearch("");
        GetUserRoleListData(RoleTypeCurrentPage, null);
      } else if (activeTab === SettingEnum.ClientIndustry) {
        setClientIndustrySearch("");
        GetClientIndustryListData(ClientIndustryCurrentPage, null);
      } else if (activeTab === SettingEnum.ClientGrouping) {
        setClientGroupingSearch("");
        GetClientGroupListData(ClientGroupingCurrentPage, null);
      } else if (activeTab === SettingEnum.LeaveType) {
        setLeaveTypeSearch("");
        GetLeaveTypeListData(LeaveTypeCurrentPage, null);
      } else if (activeTab === SettingEnum.Services) {
        setServicesSearch("");
        GetServicesListData(servicesCurrentPage, null);
      } else if (activeTab === SettingEnum.Designation) {
        setDesignationSearch("");
        GetDesignationListData(DesignationCurrentPage, null);
      } else if (activeTab === SettingEnum.StatusType) {
        setStatusTypeSearch("");
        GetStatusListData(StatusCurrentPage, null);
      } else if (activeTab === SettingEnum.KRA) {
        setKRASearch("");
        GetKRAListData(KRACurrentPage, null);
      } else if (activeTab === SettingEnum.EmailTemplate) {
        setTemplateSearch("");
        GetEmailTemplateListData(TemplateCurrentPage, null);
      } else if (activeTab === SettingEnum.ProjectStage) {
        setProjectStageSearch("");
        GetProjectStageListData(ProjectStageListCurrentPage, null);
      }

      setIsAddUpdateDone(false);
    }
  }, [isAddUpdateDone]);

  //User Role Type Search
  const handleSearchFunction = (searchValue) => {
    if (activeTab === SettingEnum.UsersRole) {
      setRoleTypeSearch(searchValue);
      GetUserRoleListData(1, searchValue);
    } else if (activeTab === SettingEnum.ClientIndustry) {
      setClientIndustrySearch(searchValue);
      GetClientIndustryListData(1, searchValue);
    } else if (activeTab === SettingEnum.ClientGrouping) {
      setClientGroupingSearch(searchValue);
      GetClientGroupListData(1, searchValue);
    } else if (activeTab === SettingEnum.LeaveType) {
      setLeaveTypeSearch(searchValue);
      GetLeaveTypeListData(1, searchValue);
    } else if (activeTab === SettingEnum.Services) {
      setServicesSearch(searchValue);
      GetServicesListData(1, searchValue);
    } else if (activeTab === SettingEnum.Designation) {
      setDesignationSearch(searchValue);
      GetDesignationListData(1, searchValue);
    } else if (activeTab === SettingEnum.StatusType) {
      setStatusTypeSearch(searchValue);
      GetStatusListData(1, searchValue);
    } else if (activeTab === SettingEnum.KRA) {
      setKRASearch(searchValue);
      GetKRAListData(1, searchValue);
    } else if (activeTab === SettingEnum.EmailTemplate) {
      setTemplateSearch(searchValue);
      GetEmailTemplateListData(1, searchValue);
    } else if (activeTab === SettingEnum.ProjectStage) {
      setProjectStageSearch(searchValue);
      GetProjectStageListData(1, searchValue);
    }
  };

  //tab Save UseEffect
  useEffect(() => {
    localStorage.setItem("selectedTab", activeTab);
    localStorage.setItem("CurrentPath", "/configure");
  }, [activeTab]);

  //User Role List Api
  const GetUserRoleListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetRoleTypeList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? RoleTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setRoleTypeListCount(response.totalCount);
        setUserRoleList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Client Industry Api
  const GetClientIndustryListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetClientIndustryList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? ClientIndustrySearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setClientIndustryListCount(response.totalCount);
        setClientIndustryList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Client Grouping Api
  const GetClientGroupListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetClientGroupList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? ClientGroupingSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setClientGroupingListCount(response.totalCount);
        setClientGroupingList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Leave Type Api
  const GetLeaveTypeListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetLeaveTypeList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? LeaveTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setLeaveTypeListCount(response.totalCount);
        setLeaveTypeList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  //User Service List Api
  const GetServicesListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetServiceList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? servicesSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setServicesListCount(response.totalCount);
        setServicesList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Designation Api
  const GetDesignationListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetDesignationList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? DesignationSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setDesignationListCount(response.totalCount);
        setDesignationList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Status Type
  const GetStatusListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetStatusList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? StatusTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setStatusListCount(response.totalCount);
        setStatusTypeList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //KRA
  const GetKRAListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetKRAList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword: searchKeyword === undefined ? KRASearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
        fromDate: "2025-04-02",
        toDate: "2025-04-02",
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setKRAListCount(response.totalCount);
        setKRAList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };

  //Email Template
  const GetEmailTemplateListData = async (i = 1, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetEmailTemplateList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? RoleTypeSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
        // fromDate: fromDate,
        // toDate: toDate,
      });
      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setEmailTemplateListCount(response.totalCount);
        setTemplateList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  //Project Stage
  const GetProjectStageListData = async (i, searchKeyword) => {
    const pageNoList = i - 1;
    try {
      setLoader(true);
      let response = await GetProjectStageList({
        moduleName: moduleName,
        pageSize: pageSize,
        pageNo: pageNoList,
        searchKeyword:
          searchKeyword === undefined ? ProjectStageSearch : searchKeyword,
        adminKeyID: authDetails.adminKeyID,
      });

      if (response.statusCode === 200) {
        setLoader(false);
        const list = response.responseData?.data;
        setProjectStageListCount(response.totalCount);
        setProjectStageList(list);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  //handle Functions
  const handleOpenStaffRoleModal = () => setStaffRoleModalOpen(true);
  const handleOpenDesignationModal = () => setDesignationModalOpen(true);

  const handleCloseStaffRoleModal = () => setStaffRoleModalOpen(false);
  const handleCloseDesignationModal = () => setDesignationModalOpen(false);

  const handleOpenServiceModal = () => setServiceModalOpen(true);
  const handleCloseServiceModal = () => setServiceModalOpen(false);
  const handleOpenClientIndustryModal = () => setClientIndustryModalOpen(true);
  const handleCloseClientIndustryModal = () =>
    setClientIndustryModalOpen(false);
  const handleOpenGroupingModal = () => setGroupingModalOpen(true);
  const handleCloseGroupingModal = () => setGroupingModalOpen(false);
  const handleOpenLeaveTypeModal = () => setLeaveTypeModalOpen(true);
  const handleCloseLeaveTypeModal = () => setLeaveTypeModalOpen(false);

  const handleConfirmBtn = async () => {
    setLoader(true);
    if (modelAction === "Delete") {
      let data;
      try {
        if (activeTab === SettingEnum.UsersRole) {
          data = await DeleteRoleType(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.ClientIndustry) {
          data = await DeleteClientIndustry(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.ClientGrouping) {
          data = await DeleteClientGroup(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.LeaveType) {
          data = await DeleteLeaveType(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.Services) {
          data = await DeleteService(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.Designation) {
          data = await DeleteDesignation(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.StatusType) {
          data = await DeleteStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.ProjectStage) {
          data = await DeleteProjectStage(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        }
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setConfirmationModal(false);
          setIsErrorOpen(true);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    } else if (modelAction === "Status") {
      try {
        let data;
        if (activeTab === SettingEnum.UsersRole) {
          data = await ChangeRoleTypeStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.ClientIndustry) {
          data = await ChangeClientIndustryStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.ClientGrouping) {
          data = await ChangeClientGroupStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.LeaveType) {
          data = await ChangeLeaveTypeStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.Services) {
          data = await ChangeServiceStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.Designation) {
          data = await ChangeDesignationStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.StatusType) {
          data = await ChangeStatusStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.KRA) {
          data = await ChangeKRAStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        } else if (activeTab === SettingEnum.ProjectStage) {
          data = await ChangeProjectStageStatus(
            moduleName,
            modelRequestData.KeyID,
            authDetails.adminKeyID
          );
        }
        if (data?.statusCode === 200) {
          setLoader(false);
          setIsAddUpdateDone(true);
          setConfirmationModal(false);
          setShowSuccessPopupModal(true);
        } else {
          setLoader(false);
          setIsErrorOpen(true);
          setConfirmationModal(false);
          const errorMessage = data?.response?.data?.errorMessage;
          setErrorMessage(errorMessage);
        }
      } catch (error) {
        setLoader(false);
      }
    }
  };

  const HandlePageChange = async (pageNumber) => {
    if (activeTab === SettingEnum.UsersRole) {
      setRoleTypeCurrentPage(pageNumber);
      await GetUserRoleListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.ClientIndustry) {
      setClientIndustryCurrentPage(pageNumber);
      await GetClientIndustryListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.ClientGrouping) {
      setClientGroupingCurrentPage(pageNumber);
      await GetClientGroupListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.LeaveType) {
      setLeaveTypeCurrentPage(pageNumber);
      await GetLeaveTypeListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.Services) {
      setServicesCurrentPage(pageNumber);
      await GetServicesListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.Designation) {
      setDesignationCurrentPage(pageNumber);
      await GetDesignationListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.StatusType) {
      setStatusCurrentPage(pageNumber);
      await GetStatusListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.KRA) {
      setKRACurrentPage(pageNumber);
      await GetKRAListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.EmailTemplate) {
      setTemplateCurrentPage(pageNumber);
      await GetEmailTemplateListData(pageNumber); // Call your function with the selected page number
    } else if (activeTab === SettingEnum.ProjectStage) {
      setProjectStageListCurrentPage(pageNumber);
      await GetProjectStageListData(pageNumber);
    }
  };

  //demo

  const [isContactPersonRoleModalOpen, setContactPersonRoleModalOpen] =
    useState(false);
  const [isStatusTypeModalOpen, setStatusTypeModalOpen] = useState(false);
  const [isKRAModalOpen, setKRAModalOpen] = useState(false);

  const handleOpenContactPersonRoleModal = () =>
    setContactPersonRoleModalOpen(true);

  const handleCloseContactPersonRoleModal = () =>
    setContactPersonRoleModalOpen(false);

  const handleOpenStatusTypeModal = () => setStatusTypeModalOpen(true);
  const handleCloseStatusTypeModal = () => setStatusTypeModalOpen(false);

  const handleOpenKRAModal = () => setKRAModalOpen(true);

  const handleCloseKRAModal = () => setKRAModalOpen(false);
  return (
    <>
      <div className="bg-gray-50 mx-auto mb-10">
        <div className="bg-white shadow-lg rounded-lg px-6">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 15px",
            }}
            className="p-4 overflow-x-auto"
          >
            <>
              <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4 border-b text-12">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    className={`px-4 py-2 whitespace-nowrap border-b-2 ${
                      activeTab === tab.id
                        ? "text-[#135EA0] border-b-2 border-[#135EA0] font-semibold"
                        : "border-transparent text-gray-900"
                    }`}
                    onClick={() => {
                      handleChangeTab(tab.id);
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </>
          </div>

          {/* Tab Content */}
          {/* User Role */}
          {activeTab === SettingEnum.UsersRole && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Users Role"
                            value={RoleTypeSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Users Role">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenStaffRoleModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Users Role
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Users Role
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Role Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {userRoleList?.map((role, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {role.roleName}
                                </td>
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {role.customerIndustry}
                                </td>
                                <td className="whitespace-nowrap text-left px-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {role.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={role.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: role.roleTypeKeyID,
                                            status:
                                              role.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="py-1 px-2 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    {role.canDelete && (
                                      <Tooltip title="Update User Role">
                                        <button
                                          className="text-[#135EA0] hover:text-[#135EA0]"
                                          onClick={() => {
                                            setModelRequestData({
                                              KeyID: role.roleTypeKeyID,
                                              Action: "Update",
                                            });
                                            handleOpenStaffRoleModal();
                                          }}
                                        >
                                          <FaEdit className="text-12" />
                                        </button>
                                      </Tooltip>
                                    )}
                                    {role.canDelete && (
                                      <Tooltip title="Delete User Role">
                                        <button
                                          className="text-gray-400 hover:text-gray-400"
                                          onClick={() => {
                                            setModelRequestData({
                                              ...modelRequestData,
                                              Name: role.roleName,
                                              KeyID: role.roleTypeKeyID,
                                              status: null,
                                            });
                                            setModelAction("Delete");
                                            setConfirmationModal(true);
                                          }}
                                        >
                                          <FaTrash className="text-12" />
                                        </button>
                                      </Tooltip>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {RoleTypeListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={RoleTypeListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {RoleTypeListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(RoleTypeListCount / pageSize)}
                          currentPage={RoleTypeCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}
          {/*Designation*/}
          {activeTab === SettingEnum.Designation && (
            <div>
              <>
                <div className="z-10 py-4 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Designation"
                            value={DesignationSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Designation">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenDesignationModal(true);
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Designation
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Designation
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Designation Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {DesignationList?.map((Designation, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {Designation.designationName}
                                </td>
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {Designation.customerIndustry}
                                </td>
                                <td className="whitespace-nowrap text-left px-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {Designation.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={
                                          Designation.status === "Active"
                                        }
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: Designation.designationKeyID,
                                            status:
                                              Designation.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="py-1 px-2 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Designation">
                                      <button
                                        className="text-[#135EA0] hover:text-[#135EA0]"
                                        onClick={() => {
                                          setModelRequestData({
                                            KeyID: Designation.designationKeyID,
                                            Action: "Update",
                                          });
                                          handleOpenDesignationModal();
                                        }}
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete Designation">
                                      <button
                                        className="text-gray-400 hover:text-gray-400"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: Designation.designationName,
                                            KeyID: Designation.designationKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {DesignationListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={DesignationListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {DesignationListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            DesignationListCount / pageSize
                          )}
                          currentPage={DesignationCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}
          {/*Status Type*/}
          {activeTab === SettingEnum.StatusType && (
            <div>
              <>
                <div className="z-10 py-4 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Status Type"
                            value={StatusTypeSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Status Type">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenStatusTypeModal(true);
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Status Type
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Status Type
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status Type
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {StatusTypeList?.map((Status, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {Status.statusName}
                                </td>
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {Status.customerIndustry}
                                </td>
                                <td className="whitespace-nowrap text-left px-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {Status.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={Status.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: Status.statusKeyID,
                                            status:
                                              Status.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="py-1 px-2 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    {Status.canDelete && (
                                      <Tooltip title="Update Status Type">
                                        <button
                                          className="text-[#135EA0] hover:text-[#135EA0]"
                                          onClick={() => {
                                            setModelRequestData({
                                              KeyID: Status.statusKeyID,
                                              Action: "Update",
                                            });
                                            handleOpenStatusTypeModal();
                                          }}
                                        >
                                          <FaEdit className="text-12" />
                                        </button>
                                      </Tooltip>
                                    )}
                                    {Status.canDelete && (
                                      <Tooltip title="Delete Status Type">
                                        <button
                                          className="text-gray-400 hover:text-gray-400"
                                          onClick={() => {
                                            setModelRequestData({
                                              ...modelRequestData,
                                              Name: Status.statusName,
                                              KeyID: Status.statusKeyID,
                                              status: null,
                                            });
                                            setModelAction("Delete");
                                            setConfirmationModal(true);
                                          }}
                                        >
                                          <FaTrash className="text-12" />
                                        </button>
                                      </Tooltip>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {StatusTypeListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={StatusTypeListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {StatusTypeListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(StatusTypeListCount / pageSize)}
                          currentPage={StatusCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}

          {/* Services Tab */}
          {activeTab === SettingEnum.Services && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Services"
                            value={servicesSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add Service Button */}
                        <Tooltip title="Add Service">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenServiceModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Service
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {
                            // setActiveTab(tab);
                            // handleTabSelect(tab);
                          }}
                        >
                          Services
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="z-1 sticky top-0">
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Service Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Frequency
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {servicesList.map((service, index) => (
                              <tr
                                key={service.serviceKeyID}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {service.serviceName}
                                </td>
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {service.customerIndustry}
                                </td>
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {service.frequencyName}
                                </td>
                                <td className="whitespace-nowrap text-left px-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {service.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={service.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: service.serviceKeyID,
                                            status:
                                              service.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>
                                <td className="p-2 whitespace-nowrap text-right pr-2 flex justify-end space-x-4">
                                  <Tooltip title="Update Service">
                                    <button className="text-[#135EA0] hover:text-[#135EA0]">
                                      <FaEdit
                                        onClick={() => {
                                          setModelRequestData({
                                            KeyID: service.serviceKeyID,
                                            Action: "Update",
                                          });
                                          handleOpenServiceModal();
                                        }}
                                        className="text-12"
                                      />
                                    </button>
                                  </Tooltip>
                                  <Tooltip title="Add Job">
                                    <button
                                      className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                                      onClick={() =>
                                        navigate("/service-job-type", {
                                          state: {
                                            serviceKeyID: service.serviceKeyID,
                                            Name: service.serviceName,
                                          },
                                        })
                                      }
                                    >
                                      + Add Job
                                    </button>
                                  </Tooltip>
                                  <Tooltip title="Delete Service">
                                    <button className="text-gray-400 hover:text-gray-400">
                                      <FaTrash
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: service.serviceName,
                                            KeyID: service.serviceKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                        className="text-12"
                                      />
                                    </button>
                                  </Tooltip>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {servicesListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={servicesListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {servicesListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(servicesListCount / pageSize)}
                          currentPage={servicesCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>{" "}
            </div>
          )}
          {/* Client Industry Tab */}
          {activeTab === SettingEnum.ClientIndustry && (
            <div>
              <>
                <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Client Industry"
                            value={ClientIndustrySearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add Client Industry Button */}
                        <Tooltip title="Add Client Industry">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                                status: null,
                              });
                              handleOpenClientIndustryModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Client Industry
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {
                            // setActiveTab(tab);
                            // handleTabSelect(tab);
                          }}
                        >
                          Client Industry
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="z-1 sticky top-0 bg-white">
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Client Industry Type
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Status
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ClientIndustryList.map((industry, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left p-1">
                                  {industry.clientIndustryName}
                                </td>
                                <td className="whitespace-nowrap text-left p-1">
                                  {industry.customerIndustry}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {industry.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={industry.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: industry.clientIndustryKeyID,
                                            status:
                                              industry.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Client Industry">
                                      <button className="text-[#135EA0] hover:text-[#135EA0]">
                                        <FaEdit
                                          onClick={() => {
                                            setModelRequestData({
                                              ...modelRequestData,
                                              KeyID:
                                                industry.clientIndustryKeyID,
                                              Action: "Update",
                                              status: null,
                                            });
                                            handleOpenClientIndustryModal();
                                          }}
                                          className="text-12"
                                        />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete Client Industry">
                                      <button className="text-gray-400 hover:text-gray-400">
                                        <FaTrash
                                          onClick={() => {
                                            setModelRequestData({
                                              ...modelRequestData,
                                              Name: industry.clientIndustryName,
                                              KeyID:
                                                industry.clientIndustryKeyID,
                                              status: null,
                                            });
                                            setModelAction("Delete");
                                            setConfirmationModal(true);
                                          }}
                                          className="text-12"
                                        />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {ClientIndustryListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={ClientIndustryListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {ClientIndustryListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            ClientIndustryListCount / pageSize
                          )}
                          currentPage={ClientIndustryCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>{" "}
            </div>
          )}
          {/* KRA */}

          {activeTab === SettingEnum.KRA && (
            <div>
              <>
                <div className="z-10 py-4 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search KRA"
                            value={KRASearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add KRA">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenKRAModal(true);
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add KRA
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          KRA
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Key Responsibility Area
                              </th>

                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Role
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status{" "}
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {KRAList?.map((KRA, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {KRA.kraName}
                                </td>
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {KRA.role}
                                </td>
                                <td className="whitespace-nowrap text-left px-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {KRA.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={KRA.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: KRA.kraKeyID,
                                            status:
                                              KRA.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="py-1 px-2 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update KRA">
                                      <button
                                        className="text-[#135EA0] hover:text-[#135EA0]"
                                        onClick={() => {
                                          setModelRequestData({
                                            KeyID: KRA.kraKeyID,
                                            Action: "Update",
                                          });
                                          handleOpenKRAModal();
                                        }}
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>
                                    {/* <Tooltip title="Delete Status Type">
                                <button
                                  className="text-gray-400 hover:text-gray-400"
                                  onClick={() => {
                                    setModelRequestData({
                                      ...modelRequestData,
                                      Name: KRA.designationName,
                                      KeyID: KRA.KRAKeyID,
                                      status: null,
                                    });
                                    setModelAction("Delete");
                                    setConfirmationModal(true);
                                  }}
                                >
                                  <FaTrash className="text-12" />
                                </button>
                              </Tooltip> */}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {KRAListCount <= 0 && (
                          <NoResultFoundModel totalRecords={KRAListCount} />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {KRAListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(KRAListCount / pageSize)}
                          currentPage={KRACurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}

          {/* Client Grouping*/}
          {activeTab === SettingEnum.ClientGrouping && (
            <div>
              <>
                <div className="bg-gray-50 mx-auto rep-width">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}

                    <div className="p-2 border-b flex flex-wrap items-center justify-between">
                      {/* Search Bar and Add Button Wrapper (Always Aligned to End of Row) */}
                      <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full sm:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Grouping"
                            value={ClientGroupingSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add KRA Button */}
                        <Tooltip title="Add Client Grouping">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                                status: null,
                              });
                              handleOpenGroupingModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                          >
                            + Add Grouping
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 text-12 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0]`}
                          onClick={() => {
                            // setActiveTab(tab);
                            // handleTabSelect(tab);
                          }}
                        >
                          Grouping{" "}
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper border border-gray-200">
                      <div className="flex-1 overflow-y-auto">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 bg-white z-10">
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Grouping Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Status
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ClientGroupingList.map((grouping) => (
                              <tr
                                key={grouping.clientGroupKeyID}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {grouping.clientGroupName}
                                </td>
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {grouping.customerIndustry}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {grouping.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={grouping.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: grouping.clientGroupKeyID,
                                            status:
                                              grouping.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>
                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip
                                      title="Update Client grouping"
                                      arrow
                                    >
                                      <button
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: grouping.clientGroupKeyID,
                                            Action: "Update",
                                            status: null,
                                          });
                                          handleOpenGroupingModal();
                                        }}
                                        className="text-[#135EA0]"
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>

                                    <Tooltip
                                      title="Delete Client grouping"
                                      arrow
                                    >
                                      <button
                                        className="text-gray-500"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: grouping.clientGroupName,
                                            KeyID: grouping.clientGroupKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {ClientGroupingListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={ClientGroupingListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {ClientGroupingListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            ClientGroupingListCount / pageSize
                          )}
                          currentPage={ClientGroupingCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>{" "}
            </div>
          )}
          {/* Leave Type */}
          {activeTab === SettingEnum.LeaveType && (
            <div>
              <>
                <div className="bg-gray-50 mx-auto rep-width">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}

                    <div className="p-2 border-b flex flex-wrap items-center justify-between">
                      {/* Search Bar and Add Button Wrapper (Always Aligned to End of Row) */}
                      <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full sm:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Leave"
                            value={LeaveTypeSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value, moduleName);
                            }}
                          />
                        </div>

                        {/* Add KRA Button */}
                        <Tooltip title="Add Leave Type">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                                status: null,
                              });
                              handleOpenLeaveTypeModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                          >
                            + Add Leave Type
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4 text-12">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0]`}
                          onClick={() => {
                            // setActiveTab(tab);
                            // handleTabSelect(tab);
                          }}
                        >
                          Leave Type{" "}
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper border border-gray-200">
                      <div className="flex-1 overflow-y-auto">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 bg-white z-10">
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Leave Type
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Customer Industry
                              </th>
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Status
                              </th>

                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {LeaveTypeList.map((leave) => (
                              <tr
                                key={leave.leaveTypeKeyID}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {leave.leaveTypeName}
                                </td>
                                <td className="p-2 whitespace-nowrap text-left pl-2">
                                  {leave.customerIndustry}
                                </td>
                                <td className="whitespace-nowrap text-left p-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {leave.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={leave.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: leave.leaveTypeKeyID,
                                            status:
                                              leave.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>
                                <td className="p-1 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Leave Type">
                                      <button
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: leave.leaveTypeKeyID,
                                            Action: "Update",
                                            status: null,
                                          });
                                          handleOpenLeaveTypeModal();
                                        }}
                                        className="text-[#135EA0]"
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>

                                    <Tooltip title="Delete leave Type">
                                      <button
                                        className="text-gray-500"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: leave.leaveTypeName,
                                            KeyID: leave.leaveTypeKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {LeaveTypeListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={LeaveTypeListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}
                    {LeaveTypeListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(LeaveTypeListCount / pageSize)}
                          currentPage={LeaveTypeCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>{" "}
            </div>
          )}
          {/* Email Template */}

          {activeTab === SettingEnum.EmailTemplate && (
            <div>
              <>
                <div className="bg-gray-50 mx-auto rep-width">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}

                    <div className="p-2 border-b flex flex-wrap items-center justify-between">
                      {/* Search Bar and Add Button Wrapper (Always Aligned to End of Row) */}

                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Email Template"
                            value={TemplateSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value);
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Email Template">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => navigate("/add-update-template")}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Email Template
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {
                            // setActiveTab(tab);
                            // handleTabSelect(tab);
                          }}
                        >
                          Email Template{" "}
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="z-1 sticky top-0 bg-white">
                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Template Name
                              </th>

                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-left whitespace-nowrap">
                                Status
                              </th>

                              <th className="p-2 border-b border-slate-200 bg-slate-50 text-right whitespace-nowrap">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {templateList?.map((template, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {template.templateName}
                                </td>
                                <td className="whitespace-nowrap text-left px-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {template.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={template.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: template.emailTemplateKeyID,
                                            status:
                                              template.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="py-1 px-2 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    <Tooltip title="Update Email tempate">
                                      <button
                                        className="text-[#135EA0] hover:text-[#135EA0]"
                                        onClick={() => {
                                          navigate("/addUpdateTemplate", {
                                            state: {
                                              KeyID:
                                                template.emailTemplateKeyID,
                                              Action: "Update",
                                            },
                                          });
                                        }}
                                      >
                                        <FaEdit className="text-12" />
                                      </button>
                                    </Tooltip>
                                    <Tooltip title="Delete Email tempate">
                                      <button
                                        className="text-gray-400 hover:text-gray-400"
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            Name: template.templateName,
                                            KeyID: template.emailTemplateKeyID,
                                            status: null,
                                          });
                                          setModelAction("Delete");
                                          setConfirmationModal(true);
                                        }}
                                      >
                                        <FaTrash className="text-12" />
                                      </button>
                                    </Tooltip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {EmailTemplateListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={EmailTemplateListCount}
                          />
                        )}
                      </div>
                      {/* Pagination */}
                      {/* Pagination */}
                      {EmailTemplateListCount > pageSize && (
                        <div className="flex justify-end ">
                          <PaginationComponent
                            totalPages={Math.ceil(
                              EmailTemplateListCount / pageSize
                            )}
                            currentPage={TemplateCurrentPage}
                            onPageChange={HandlePageChange}
                          />
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                    {/* </div> */}
                  </div>
                </div>
              </>{" "}
            </div>
          )}
          {activeTab === SettingEnum.ProjectStage && (
            <div>
              <>
                <div className="z-10 py-4 space-y-6 mx-auto rep-width mx-auto px-4">
                  <div className="h-full bg-white shadow rounded-lg flex flex-col">
                    {/* Header Section */}
                    <div className="p-2 border-b flex flex-wrap items-center justify-between gap-2 md:gap-4">
                      {/* Search Bar and Add Button Wrapper */}
                      <div className="flex flex-col md:flex-row items-center w-full md:w-auto gap-2 md:gap-4 ml-auto">
                        {/* Search Bar */}
                        <div className="relative flex items-center w-full md:w-64">
                          <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                          <input
                            type="text"
                            className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                            placeholder="Search Project Stage"
                            value={ProjectStageSearch}
                            onChange={(e) => {
                              handleSearchFunction(e.target.value);
                            }}
                          />
                        </div>

                        {/* Add Subscription Button */}
                        <Tooltip title="Add Project Stage">
                          <button
                            id="addBtn"
                            type="button"
                            onClick={() => {
                              setModelRequestData({
                                KeyID: null,
                                Action: null,
                              });
                              handleOpenStageModal();
                            }}
                            className="text-white bg-[#E86B1B] rounded-md px-3 py-1 text-12 text-[#135EA0] focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all w-full md:w-auto"
                          >
                            + Add Project Stage
                          </button>
                        </Tooltip>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "4px 15px",
                      }}
                      className="border-b p-4 overflow-x-auto"
                    >
                      <div className="flex space-x-4">
                        <button
                          className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                          onClick={() => {}}
                        >
                          Project Stage
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    {/* <div className="p-4"> */}
                    <div className="flex flex-col table_wrapper  border-gray-200">
                      <div className="flex-1 overflow-y-auto  ">
                        <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                          <thead>
                            <tr className="sticky top-0 z-10 bg-slate-200 shadow-sm">
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Project Stage Name
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Project Stage Name
                              </th>

                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-left text-12 font-semibold">
                                Status
                              </th>
                              <th className="px-2 py-2 bg-slate-50 border-x border-t border-slate-300 text-right text-12 font-semibold">
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {ProjectStageList?.map((Stage, index) => (
                              <tr
                                key={index}
                                className="hover:bg-slate-50 border-b border-slate-200"
                              >
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {Stage.projectStageName}
                                </td>
                                <td className="whitespace-nowrap text-left py-1 px-2">
                                  {Stage.customerIndustry}
                                </td>

                                <td className="whitespace-nowrap text-left px-2">
                                  <div className="flex items-center space-x-4">
                                    <span
                                      className={`text-12 font-medium w-[35px]`}
                                    >
                                      {Stage.status === "Active"
                                        ? "Active"
                                        : "InActive"}
                                    </span>
                                    <Tooltip title="Change Status">
                                      <Android12Switch
                                        checked={Stage.status === "Active"}
                                        onClick={() => {
                                          setModelRequestData({
                                            ...modelRequestData,
                                            KeyID: Stage.projectStageKeyID,
                                            status:
                                              Stage.status === "Active"
                                                ? "InActive"
                                                : "Active",
                                          });
                                          setModelAction("Status");
                                          setConfirmationModal(true);
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                </td>

                                <td className="py-1 px-2 border-b border-gray-400 text-12">
                                  <div className="flex justify-end gap-2">
                                    {Stage.canDelete && (
                                      <Tooltip title="Update Project Stage">
                                        <button
                                          className="text-[#135EA0] hover:text-[#135EA0]"
                                          onClick={() => {
                                            setModelRequestData({
                                              KeyID: Stage.projectStageKeyID,
                                              Action: "Update",
                                            });
                                            handleOpenStageModal();
                                          }}
                                        >
                                          <FaEdit className="text-12" />
                                        </button>
                                      </Tooltip>
                                    )}
                                    {Stage.canDelete && (
                                      <Tooltip title="Delete Project Stage">
                                        <button
                                          className="text-gray-400 hover:text-gray-400"
                                          onClick={() => {
                                            setModelRequestData({
                                              ...modelRequestData,
                                              Name: Stage.kraName,
                                              KeyID: Stage.projectStageKeyID,
                                              status: null,
                                            });
                                            setModelAction("Delete");
                                            setConfirmationModal(true);
                                          }}
                                        >
                                          <FaTrash className="text-12" />
                                        </button>
                                      </Tooltip>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {ProjectStageListCount <= 0 && (
                          <NoResultFoundModel
                            totalRecords={ProjectStageListCount}
                          />
                        )}
                      </div>
                    </div>
                    {/* </div> */}

                    {ProjectStageListCount > pageSize && (
                      <div className="flex justify-end ">
                        <PaginationComponent
                          totalPages={Math.ceil(
                            ProjectStageListCount / pageSize
                          )}
                          currentPage={ProjectStageListCurrentPage}
                          onPageChange={HandlePageChange}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </>
            </div>
          )}
        </div>
        <ErrorModal
          isOpen={isErrorOpen}
          onClose={() => setIsErrorOpen(false)}
          errorMessage={errorMessage}
        />

        {isStaffRoleModalOpen && (
          <StaffRoleModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isStaffRoleModalOpen}
            onClose={handleCloseStaffRoleModal}
          />
        )}

        {isStatusTypeModalOpen && (
          <AddUpdateStatusTypeModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isStatusTypeModalOpen}
            onClose={handleCloseStatusTypeModal}
          />
        )}

        {isdesignationModalOpen && (
          <AddUpdateContactPersonRoleModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isdesignationModalOpen}
            onClose={handleCloseDesignationModal}
          />
        )}

        {isKRAModalOpen && (
          <AddUpdateKRAModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isKRAModalOpen}
            onClose={handleCloseKRAModal}
          />
        )}

        {isServiceModalOpen && (
          <AddUpdateServiceModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isServiceModalOpen}
            onClose={handleCloseServiceModal}
          />
        )}
        {isClientIndustryModalOpen && (
          <AddUpdateClientIndustryModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isClientIndustryModalOpen}
            onClose={handleCloseClientIndustryModal}
          />
        )}
        {isGroupingOpen && (
          <AddUpdateClientGroupingModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isGroupingOpen}
            onClose={handleCloseGroupingModal}
          />
        )}
        {isLeaveTypeOpen && (
          <AddUpdateLeaveTypeModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={isLeaveTypeOpen}
            onClose={handleCloseLeaveTypeModal}
          />
        )}

        {OpenProjectStageListModel && (
          <ProjectStageAddUpdateModal
            modelRequestData={modelRequestData}
            setIsAddUpdateDone={setIsAddUpdateDone}
            isOpen={OpenProjectStageListModel}
            onClose={handleCloseStageModal}
          />
        )}
        <ConfirmationModal
          show={confirmationModal}
          onHide={() => setConfirmationModal(false)}
          actionType={modelAction}
          onConfirm={() => handleConfirmBtn()}
          modelRequestData={modelRequestData}
        />

        <SuccessModal
          isOpen={showSuccessPopupModal}
          onClose={() => setShowSuccessPopupModal(false)}
          modelAction={modelAction}
          actionMessage={
            modelAction === "Status"
              ? "Status has been changed successfully!"
              : modelRequestData.Name
          }
        />
      </div>
    </>
  );
}

export default Configure;
